const FormLabel = {
  baseStyle: {
    fontSize: '14px',
    color: '#0A0D14',
    fontWeight: 'medium',
    lineHeight: '142.857%',
    letterSpacing: '-0.084px',
    mb: '4px',
    small: {
      color: 'red',
      fontWeight: 'bold'
    }
  },
};

export default FormLabel;
